import React, { useContext, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { firebaseAuth } from '../../../services/firebase'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import {
  VendorContextInterface,
  VendorContext
} from '../../../contexts/vendorContext'
import { getProfile, isEmailInvited } from '../../../services/vendorService'
import { toast } from 'react-toastify'
import LoginForm from '../../common/forms/loginForm'
import { AppError, FirebaseError } from '../../../config/enums'
import constants from '../../../config/constants'
import { Link } from 'react-router-dom'

const handleEmailLogin = async (
  email: string,
  password: string,
  vendorContext: VendorContextInterface
) => {
  await firebaseAuth()
    .signInWithEmailAndPassword(email, password)
    .then(res => {
      const userId = res?.user?.uid as string
      return getProfile(userId)
    })
    .then(profile => {
      if (profile) {
        // case: user has a vendor profile
        // action: save profile to context and complete login
        vendorContext.setProfile(profile)
        return true
      } else {
        // case: user does not have a vendor profile!
        // action: signout and show an error message
        firebaseAuth().signOut()
        const message = friendlyMessageFor(
          AppError.unregisteredAccount as string
        ).replace('%s', 'vendor')
        toast.error(message, { autoClose: false })
        return false
      }
    })
    .catch(err => {
      if (err.code === FirebaseError.authWrongPassword) {
        isEmailInvited(email).then(invited => {
          const message = invited
            ? constants.alertError.auth.emailInvited
            : friendlyMessageFor(err.code as string)
          toast.error(message, { autoClose: false })
        })
      } else {
        console.error('Vendor login error:', err)
        const message = friendlyMessageFor(err.code as string)
        toast.error(message, { autoClose: false })
      }
      return false
    })
}

function LogIn() {
  const vendorContext = useContext(VendorContext)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div className="box">
      <Row className="pb-3">
        <Col data-testid="onboarding-signin-text">
          <h2>Sign In</h2>
        </Col>
      </Row>
      <Row data-testid="onboarding-signin">
        <Col>
          <LoginForm
            emailLoginCallback={(email, password) => {
              setIsLoading(true)
              handleEmailLogin(
                email,
                password,
                vendorContext as VendorContextInterface
              ).then(() => {
                setIsLoading(false)
              })
            }}
            isLoading={isLoading}
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-center mt-4">
          <span className="gray-text">
            Don't have an account?{' '}
            <Link to="/vendor/login?action=signup">Sign up here</Link>.
          </span>
        </Col>
      </Row>
    </div>
  )
}

export default LogIn
